<div class="hero" *ngIf="(resultReady || !pastDate) && translationLoaded">
  <qai-inner-wrap class="hero-wrap">
    <h2 class="hero-title">{{'results.ELEVATE_CONVERSATION_SKILLS' | transloco}}</h2>
    <p class="hero-description">
      {{'results.SKILLS_NOTE' | transloco}}
    </p>
  </qai-inner-wrap>
</div>

<qai-inner-wrap class="body" *ngIf="translationLoaded">
  <div class="content">
    <ng-container *ngIf="resultReady">
      <h2 class="section-heading">{{'results.SKILLS_SUMMARY_TITLE' | transloco}}</h2>

      <button
        qai-link
        class="skills-link"
        (click)="$event.stopPropagation(); openModal()"
      >
        {{'results.LEARN_MORE_ABOUT_SKILLS' | transloco}}
        <qai-icon kind="chevron-right" qaiSlot="end" />
      </button>

      <div class="skills-list">
        <qai-skill-highlight
          *ngFor="let skill of skillDetailsArray; let i = index"
          id="{{ 'target-' + i }}"
          class="skills-list-item"
          [title]="skill.title"
        >
          <div
            class="svg-icon"
            [ngClass]="skill.score"
            aria-label="My icon"
            [inlineSVG]="'/assets/img' + skill.icon"
            qaiSlot="image"
          ></div>
          <qai-badge
            class="badge"
            [label]="'results.' + (skill.score | uppercase) | transloco"
            [kind]="getScoreBadgeKind(skill.score)"
            shape="round"
            qaiSlot="status"
          />
        </qai-skill-highlight>
      </div>

      <h2 class="section-heading">{{'results.SKILLS_FEEDBACK_LABEL' | transloco}}</h2>

      <div class="feedback-list">
        <qai-skill-highlight
          *ngFor="let skill of skillDetailsArray; let i = index"
          id="{{ 'target-' + i }}"
          [title]="skill.title"
        >
          <div
            qaiSlot="image"
            class="svg-icon"
            [ngClass]="skill.score"
            aria-hidden="true"
            [inlineSVG]="'/assets/img' + skill.icon"
          ></div>

          <qai-badge
            qaiSlot="status"
            class="badge"
            [label]="'results.' + (skill.score | uppercase) | transloco"
            [kind]="getScoreBadgeKind(skill.score)"
            shape="round"
          />

          <div qaiSlot="content" class="feedback-content">
            <div>{{ skill.feedback }}</div>
            <div class="list" *ngFor="let action of skill.actionItems">
              <div class="list-item">
                <img src="/assets/icons/checkbox.svg" />
                <p>{{ action }}</p>
              </div>
            </div>
          </div>
        </qai-skill-highlight>
      </div>
    </ng-container>

    <div *ngIf="!resultReady" class="hang-tight">
      <app-hang-tight
        [isErrorLoadingScreen]="isErrorLoadingScreen"
        [displayButtonLoadingScreen]="displayButtonLoadingScreen"
        [titleLoadingScreen]="titleLoadingScreen"
        [messageLoadingScreen]="messageLoadingScreen"
        [pastDate]="pastDate"
      >
      </app-hang-tight>
    </div>
  </div>
</qai-inner-wrap>

<ng-template #modalTemplate>
  <div class="custom-dialog-container">
    <div
      class="container-modal"
      appClickedOutside
      (clickedOutside)="closeModal()"
    >
      <div class="modal-header">
        <h2>{{'results.WHAT_ARE_SKILLS_TITLE' | transloco}}</h2>
        <button type="button" class="close-button" (click)="closeModal()">
          <qai-icon kind="x-close" size="28px" />
        </button>
      </div>
      <div class="modal-body">
        <p>
          {{'results.SKILLS_DESCRIPTION' | transloco}}
        </p>
        <h5>{{'results.PROFICIENCY_SCALE_TITLE' | transloco}}</h5>
        <div class="skill-pills">
          <qai-badge
            *ngFor="let skill of skillKeys"
            [label]="'results.' + (skill | uppercase) | transloco"
            [kind]="getScoreBadgeKind(skill)"
            shape="round"
          />
        </div>
        <div class="skill-details" *ngFor="let skill of skillDetailsArray">
          <h2 class="skill-title">{{ skill.title }}</h2>
          <p class="description">{{ skill.description }}</p>
        </div>
      </div>
    </div>
  </div>
</ng-template>
